<template>
  <div id="newPostMobile">
    <input type="text" v-model="post.title" :class="{invalid: $validate.error('post.title')}">
    <label for="">{{ $t("form.title") }}</label>
    <input type="text" v-model="post.subTitle" :class="{invalid: $validate.error('post.subTitle')}">
    <label for="">{{ $t("form.subtitle") }}</label>
    <div class="row">
      <div class="col">

        <datetime id="startDate" zone="UTC" v-model="post.start" value-zone="America/New_York" :format="DateTime.DATE_MED" :input-class="{invalid: $validate.error('post.start')}"
                  :disabled="!post" :min-datetime="new Date().toISOString()"></datetime>
        <label for="startDate">
          <span>{{ $t("billboard.publication_date") }}</span>
          <img class="icon" src="@/assets/img/icons/calendar_2.png" :class="{disabled: !post}">
        </label>

<!--        <input type="date" v-model="post.start" :class="{invalid: $validate.error('post.start')}">-->
<!--        <label for="">{{ $t("billboard.publication_date") }}</label>-->
      </div>
      <div class="col">

        <datetime id="endDate" zone="UTC" v-model="post.end" value-zone="America/New_York" :format="DateTime.DATE_MED" :input-class="{invalid: $validate.error('post.end')}"
                  :disabled="!post" :min-datetime="new Date().toISOString()"></datetime>
        <label for="endDate">
          <span>{{ $t("billboard.publication_date") }}</span>
          <img class="icon" src="@/assets/img/icons/calendar_2.png" :class="{disabled: !post}">
        </label>

<!--        <input type="date" v-model="post.end" :class="{invalid: $validate.error('post.end')}">-->
<!--        <label for="">{{ $t("billboard.end_date") }}</label>-->
      </div>
    </div>
    <textarea name="" id="" cols="30" rows="10" v-model="post.body" :class="{invalid: $validate.error('post.body')}"></textarea>
    <label for="">{{ $t("form.content") }}</label>
    <FileUploader unique-key="mobile" @upload="setImageData"></FileUploader>
    <!-- <input type="text">
    <label for="">{{ $t("form.add_photo") }}</label> -->
    <div class="buttons">
      <div class="btn btn-secondary" @click="back">{{ $t("navigation.back") }}</div>
      <div class="btn btn-primary" @click="publish">{{ $t("navigation.publish") }}</div>
    </div>
  </div>
</template>

<script>

  import FileUploader from "../../components/FileUploader";
  import { DateTime } from "luxon";
  import moment from 'moment';
  
  export default {
    name: "NewPostMobile",
    
    props: {
      post:Object,
      back: Function,
      publish: Function,
      setImageData: Function
    },

    data() {
      return {
        DateTime,
      }
    },
    
    components: {
      FileUploader
    },
    
    validate: {
      "post.title": {required: true},
      "post.subTitle": {required: false},
      "post.body": {required: true},
      "post.start": {required: true, date: true},
      "post.end": {required: true, date: true}
    },
  }
</script>

<style lang="scss" scoped>
  #newPostMobile {
    background-color: #f2f3f4;
    padding: 20px;
  }
  
  input, textarea {
    width: 100%;
  }
  
  .buttons {
    display: flex;
    margin-top: 10px;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }
  
  .row {
    display: flex;
    .col {
      flex-grow: 1;
      flex-basis: 0;
      overflow: hidden;
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }
</style>